(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    angular
        .module('ib-passenger-docs-module')
        .component('ibPassengerDocs', {
            controller: 'PassengerDocsController',
            controllerAs: 'pasDocsCtrl',
            bindings: {
                pasDocsData: '=',
                index: '@',
                countries: '<',
                containerForm: '=',
                travelInfo: '<'
            },
            templateUrl: ['CheckinRouterConstants', function (CheckinRouterConstants) {
                return CheckinRouterConstants.templatesRoute + 'ib-passenger-docs-view.html';
            }]
        });

})();